import { CheckboxInput } from '../baseInputs'

const LexusReserveTanCs = () => {
  const tancslink =
    'https://www.lexus.co.uk/content/dam/lexus/nmsc/united-kingdom/cross-model/lexus-reserve-terms-and-conditions-2025.pdf'
  return (
    <div className="mt-8">
      <CheckboxInput name={'Lexus_reserve_tandcs'}>
        Please tick to confirm you have read and understood the{' '}
        <a
          className="underline"
          href={tancslink}
          target={'_blank'}
          rel={'noopener noreferrer'}
          data-gt-name="ctaevent"
          data-gt-action="tandcs-click-link"
          data-gt-label={tancslink}
        >
          T&Cs.
        </a>
      </CheckboxInput>
    </div>
  )
}

export default LexusReserveTanCs
